export const { format: floatFormat } = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  currencyDisplay: "symbol",
});

export const getStatusColor = (status: string) => {
  const stat = status?.toLowerCase();
  return stat?.includes("active") ? "#4caf50" : "#a9a9a9";
};

export const slugify = (value: string) =>
  value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
